import TopBottom from './TopBottom';
import ShowDate from './ShowDate';
import LabelIcon from './LabelIcon';
import ShowGender from './ShowGender';
import LabelDescripScore from './LabelDescripScore';
import LabelSubVertical from './LabelSubVertical';
import LabelForm from './LabelForm';
import LabelInlineIcon from './LabelInlineIcon';

const Export = {
  TopBottom,
  ShowDate,
  LabelIcon,
  ShowGender,
  LabelDescripScore,
  LabelSubVertical,
  LabelForm,
  LabelInlineIcon,
};

export default Export;
